import React from 'react';
import { Spin } from "antd";

export const Loader = () => (
  <div className="align-center">
    <Spin size="large" tip="Loading..." />
  </div>
);

export default Loader;